module.exports = __webpack_public_path__ + "static/media/zhongxuejy.77fc6676.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zhongxuejy.png
// module id = 694
// module chunks = 0 1